import { render } from "./installations.vue?vue&type=template&id=6a905960"
import script from "./installations.vue?vue&type=script&lang=js"
export * from "./installations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__